module.exports = __webpack_public_path__ + "img/menu6.a7ae91df.jpg";